import { render, staticRenderFns } from "./Banner2.vue?vue&type=template&id=3c417a07&scoped=true"
import script from "./Banner2.vue?vue&type=script&lang=js"
export * from "./Banner2.vue?vue&type=script&lang=js"
import style0 from "./Banner2.vue?vue&type=style&index=0&id=3c417a07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c417a07",
  null
  
)

export default component.exports